// extracted by mini-css-extract-plugin
export var noSpinners = "_ni-6";
export var percentageInput = "_ni-7";
export var variantColor1 = "_ni-0";
export var variantColor2 = "_ni-1";
export var variantColor3 = "_ni-2";
export var variantColor4 = "_ni-3";
export var variantColor5 = "_ni-4";
export var variantColor6 = "_ni-5";